export default __webpack_public_path__ + "static/media/queued-image.bd842bc5.png";